import { render } from "./FlutterEnvironmentSetup.vue?vue&type=template&id=7a4544b2&lang=true"
import script from "./FlutterEnvironmentSetup.vue?vue&type=script&lang=js"
export * from "./FlutterEnvironmentSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__